/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Docx_QInputs */

const en_wc_faq_docx_q = /** @type {(inputs: Wc_Faq_Docx_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can WordCraft open my Word documents?`)
};

/**
* | output |
* | --- |
* | "Can WordCraft open my Word documents?" |
*
* @param {Wc_Faq_Docx_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_docx_q = /** @type {((inputs?: Wc_Faq_Docx_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Docx_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_docx_q(inputs)
});
export { wc_faq_docx_q as "wc.faq.docx.q" }